import { Location } from '@angular/common';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { Component, inject, OnInit } from '@angular/core';

import { IProspectusRouteState } from '../../../../components/core/models/prospectus-route-state.interface';
import {
  CAMPAIGN_AGREEMENT_ROUTE,
  CHOICE_PAYMENT_METHOD_ROUTE,
  HOME_ROUTE,
  PURCHASE_ROUTE,
  SIGN_AGREEMENTS_ROUTE,
  WALLET_CASH_IN_ROUTE,
} from '../../../../data-access/constants/app-routes';
import { EpdfType } from '../../../../components/core/models/instruments.enum';
import { getPDFSource, SYMBOL_MAP } from '../../../../components/core/models/static-pdf-maps';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { RouteStateService } from '@client-monorepo/common/utilities';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'app-prospectus',
  templateUrl: './prospectus.component.html',
  styleUrls: ['./prospectus.component.scss'],
  standalone: true,
  imports: [PdfViewerModule, NgxAppBarComponent, SpinnerComponent],
})
export class ProspectusComponent implements OnInit {
  //The PDF file is temporary static and will be different for every asset
  loading = true;
  state: IProspectusRouteState;

  pdfSrc = '';
  pageTitle = 'امیدنامه';
  pdfBlob: Uint8Array;
  private location = inject(Location);
  private routeState = inject(RouteStateService);
  private navigationService = inject(WealthNavigationService);

  ngOnInit(): void {
    this.state = this.routeState.getAll();
    if (!this.state?.symbol) {
      this.navigationService.navigate([HOME_ROUTE]);
    } else {
      this.getInfo();
    }
  }

  async getInfo() {
    if (this.state?.agreement) {
      await this.convertToUint8Array();
      this.pageTitle = this.state.agreementTitle;
    } else {
      if (this.state.pdfType === EpdfType.STATUTE) {
        this.pageTitle = 'اساسنامه';
      } else if (this.state.pdfType === EpdfType.REGULATIONS) {
        this.pageTitle = 'قوانین و مقررات';
      } else if (this.state.pdfType === EpdfType.CONTRACT) {
        this.pageTitle = 'قرارداد دیجی‌پی';
      } else if (this.state.pdfType === EpdfType.RISKSTATEMEBT) {
        this.pageTitle = 'بیانیه ریسک';
      }
      if (this.state.pdfType === EpdfType.RISKSTATEMEBT) {
        this.pdfSrc = getPDFSource(SYMBOL_MAP.get('CROWD'), this.state.pdfType);
      } else {
        if (this.state.type === 'IPO') {
          this.pdfSrc = getPDFSource(SYMBOL_MAP.get(this.state.type), this.state.pdfType);
        } else {
          this.pdfSrc = getPDFSource(SYMBOL_MAP.get(this.state.symbol), this.state.pdfType);
        }
      }
    }
  }

  async convertToUint8Array() {
    this.pdfBlob = new Uint8Array(await this.state?.pdfFile.arrayBuffer());
  }

  onBackHandler() {
    if (this.state.type === 'campaign') {
      this.navigationService.navigateWithState([CAMPAIGN_AGREEMENT_ROUTE], {
        state: {
          campaignCode: this.state.campaignData.campaignCode,
          userInfo: this.state.campaignData.userInfo,
          agreements: this.state.campaignData.agreements,
        },
      });
    } else if (this.state.type === 'IPO') {
      this.navigationService.navigate([CHOICE_PAYMENT_METHOD_ROUTE, this.state.symbol], {
        state: this.state,
      });
    } else {
      if (this.state.symbol === 'treasury') {
        this.navigationService.navigateWithState([WALLET_CASH_IN_ROUTE, this.state.symbol], {
          state: this.state,
        });
      } else {
        if (this.state.agreement) {
          this.navigationService.navigateWithState([SIGN_AGREEMENTS_ROUTE], {
            state: this.state,
          });
        } else if (this.state.backToProfile) {
          this.location.back();
        } else {
          if (this.state.investmentType === 'CrowdFund') {
            this.navigationService.navigateWithOptions([PURCHASE_ROUTE, this.state.symbol], {
              queryParams: { crowdFunding: true },
              state: this.state,
            });
          } else {
            this.navigationService.navigateWithState([this.state?.type === 'sell' ? 'sell' : 'purchase', this.state?.symbol], {
              state: {
                amount: this.state?.amount,
                agreementChecked: this.state?.agreementChecked,
              },
            });
          }
        }
      }
    }
  }
}
